import { Col, Container, Row } from 'reactstrap';

import { Button, LoadingSpinner, NoData, ShimmerImage } from 'Elements';
import { Title } from 'Styles';
import styled from 'styled-components';
import { rgba } from 'polished';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useProfileJobs } from 'src/hooks/useJob';
import styles from 'partials/homepage/card/profile-job-card.module.scss';
import { Logo } from 'src/types/BusinessPartner';
import { truncateToWord } from 'src/helpers/Utils';
import { Colors } from 'src/types/Color';

type Props = {
	isLoadingProfile: boolean;
	header: {
		description: string;
		headerImage: Logo;
		headerTitle: string;
		logo: Logo;
		slogan: string;
		themeColor: number;
	};
	internships: {
		enabled: boolean;
		headline: string;
	};
};

const Card = styled.article<any>`
	${({ $bgColor }) =>
		$bgColor &&
		`
		&:hover {
			box-shadow: 0 5px 10px ${rgba($bgColor, 0.1)};
		}`}};
`;

export const CommunityPartnerPreviewInternshipSection = ({
	isLoadingProfile,
	internships,
	header
}: Props) => {
	const { t } = useTranslation();
	const perRow = 3;
	const defaultImage = '/assets/img/default-image.png';
	const [next, setNext] = useState(perRow);
	const { data, isLoading } = useProfileJobs({
		status: 1,
		pageSize: 20,
		pageNumber: 1,
		keyword: '',
		kind: 1
	});

	const handleMore = () => {
		setNext(next + perRow);
	};
	return data?.items?.length !== 0 ? (
		<section className="position-relative mb-5">
			<Container>
				{isLoadingProfile && (
					<div className="d-flex align-items-center justify-content-center">
						<LoadingSpinner />
					</div>
				)}
				{!isLoadingProfile && internships && (
					<div className="position-relative">
						<Title
							textColor="text-gray-5"
							className="h3 fw-700 mb-0 text-center">
							{internships?.headline}
						</Title>
					</div>
				)}
				{!isLoading && (
					<Row className="justify-content-center mt-3">
						{data &&
							data?.items?.slice(0, next)?.map((internship) => {
								return (
									<Col
										md={6}
										lg={4}
										key={internship.id}
										className="mb-4">
										<Card
											className={styles.card}
											$bgColor={header?.themeColor}>
											<div
												className={styles.imageWrapper}>
												<ShimmerImage
													src={
														internship
															?.featuredPhoto
															?.url ||
														defaultImage
													}
													defaultImage={defaultImage}
													alt={internship?.title}
													width={500}
													height={500}
													className={styles.image}
												/>
												
											</div>
											<div className="flex-grow-1 d-flex flex-column gap-2">
												
												<h4 className="text-break fs-5 mb-0 lh-sm">
													{internship.title}
												</h4>
												{internship.shortDescription && (
													<div
														className="flex-grow-1 lh-md text-break text-gray-3"
														dangerouslySetInnerHTML={{
															__html: truncateToWord(
																internship.shortDescription,
																25
															)
														}}
													/>
												)}
											</div>
										</Card>
									</Col>
								);
							})}
					</Row>
				)}
				{!isLoading && data && data?.items?.length === 0 && (
					<NoData
						message={t('title.no-jobs-found')}
						iconClassName="w-40 w-md-30 w-xl-20"
					/>
				)}
				{!isLoading && data && data?.items?.length > next && (
					<div className="d-flex align-items-center justify-content-center mt-3">
						<Button
							size="lg"
							color={Colors['border-gray-4']}
							className="fs-base"
							onClick={handleMore}>
							{t('button.more-jobs')}
						</Button>
					</div>
				)}
				{isLoading && <LoadingSpinner />}
			</Container>
		</section>
	) : (
		<></>
	);
};
